var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 7.71045V16.2894L20.2776 11.9999L12.8984 7.71045Z",
    fill: "#062B31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3942 4.28606C29.0607 2.99267 28.0778 1.97394 26.8302 1.62851C24.5682 1 15.5 1 15.5 1C15.5 1 6.4312 1 4.16983 1.62786C2.9222 1.97394 1.93935 2.99267 1.60585 4.28606C1 6.63 1 11.5211 1 11.5211C1 11.5211 1 16.4122 1.60585 18.7568C1.93935 20.0502 2.9222 21.0267 4.16983 21.3721C6.4312 22 15.5 22 15.5 22C15.5 22 24.5688 22 26.8302 21.3721C28.0778 21.0261 29.0607 20.0502 29.3942 18.7568C30 16.4129 30 11.5211 30 11.5211C30 11.5211 30 6.63 29.3942 4.28606Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
export default SvgYoutube;